
import React, { createContext, useReducer, useContext } from 'react';
import OnlineAccessesService from '../services/OnlineAccessesService';
import OnlineAccessesReducer from '../reducers/OnlineAccessesReducer';
import {
  ONLINEACCESSS_RECEIVED,
  SET_ONLINEACCESS,
  CREATE_ONLINEACCESS,
  SET_PROPERTY_ONLINEACCESS,
} from "../types/online_accesses";
import { ModalContext } from './ModalContext';
import { HIDE_SPINNER, SET_TOTAL, SHOW_SPINNER } from "../types";

const initialState = {
  online_accesses: null,
  online_access: null,
};

export const OnlineAccessesContext = createContext(initialState);

export const OnlineAccessesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(OnlineAccessesReducer, initialState);

  const { alert, success, clearModal } = useContext(ModalContext);

  const getOnlineAccesses = (filters) => {
    OnlineAccessesService.getOnlineAccesses(filters)
      .then((response) => {
        const { total, online_accesses } = response.data;
        dispatch({ type: SET_TOTAL, payload: total });
        dispatch({ type: ONLINEACCESSS_RECEIVED, payload: online_accesses });
      })
      .catch((error) => {
        alert(error);
      });
  };

  const getSingleOnlineAccess = (online_access_id) => {
    OnlineAccessesService.getSingleOnlineAccess(online_access_id)
      .then((response) => {
        const { online_access } = response.data;
        dispatch({ type: SET_ONLINEACCESS, payload: online_access });
      })
      .catch((error) => {
        alert(error);
      });
  };

  const setOnlineAccess = (online_access) => {
    dispatch({ type: SET_ONLINEACCESS, payload: online_access });
  };

  const createOnlineAccess = () => {
    dispatch({ type: CREATE_ONLINEACCESS });
  };

  const setPropertyOnlineAccess = (key, value) => {
    dispatch({ type: SET_PROPERTY_ONLINEACCESS, payload: { key, value } });
  };

  const saveOnlineAccess = (online_access, callback) => {
      dispatch({ type: SHOW_SPINNER });
      let service = OnlineAccessesService.putOnlineAccess;
      if(isNaN(parseInt(online_access.online_access_id))) {
        service = OnlineAccessesService.postOnlineAccess;
      }
      service(online_access).then(() => {
        success("online_access saved.");
        dispatch({ type: HIDE_SPINNER });
        clearModal();
        if(typeof callback === "function") {
          callback();
        }
      })
      .catch((error) => {
        dispatch({ type: HIDE_SPINNER });
        alert(error);
      });
  };

  const deleteOnlineAccess = (online_access_id, callback) => {
     dispatch({ type: SHOW_SPINNER });
    OnlineAccessesService.deleteOnlineAccess(online_access_id).then(() => {
      success("online_access deleted.");
      dispatch({ type: HIDE_SPINNER });
      clearModal();
      if(typeof callback === "function") {
        callback();
      }
    }).catch(error => {
      dispatch({ type: HIDE_SPINNER });
      alert(error);
    })
  };

 

  return (
    <OnlineAccessesContext.Provider
    value={{
      ...state,
      setOnlineAccess,
      getOnlineAccesses,
      saveOnlineAccess,
      deleteOnlineAccess,
      createOnlineAccess,
      getSingleOnlineAccess,
      setPropertyOnlineAccess,

    }}
  >
    {children}
  </OnlineAccessesContext.Provider>
);
};
